import { Provider } from "react-redux";
import "./App.css";
import Body from "./components/Body";
import Header from "./components/Header"; 
import store from "./utils/store";
import { createBrowserRouter,RouterProvider } from "react-router-dom";
import MainContainer from "./components/MainContainer";   
import Watchpage from "./components/Watchpage";

const appRouter = createBrowserRouter([
  {
    path:"/", 
    element:<Body />,
    children:[
      {
        path:"/",
        element:<MainContainer />
      },
      {
        path:"/watch",
        element:<Watchpage />
      },
      {
        path:"/",
        element:<Watchpage />
      }
    ]
  }
])

function App() {
  return (
    <Provider store={store}>
      <div className="App"> 
        <Header />
        <RouterProvider router={appRouter}></RouterProvider>
      </div>
    </Provider>
  );
}

export default App;
